import React, { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { TaskId } from 'api/models';
import { ClassNameProps } from 'components/ozone-component';
import { getTaskDetailUrl, TaskDrawerTab } from 'hooks/use-navigate-to-task';

interface Props extends ClassNameProps {
  children: ReactNode;
  openApprovalTab?: boolean;
  id: TaskId;
}

export const LinkToTask: FC<Props> = ({
  className,
  children,
  openApprovalTab = false,
  id,
  ...rest
}) => (
  <Link
    className={className}
    to={{
      hash: getTaskDetailUrl(id, {
        tab: openApprovalTab
          ? TaskDrawerTab.Approvals
          : TaskDrawerTab.Conversations,
      }),
    }}
    {...rest}
  >
    {children}
  </Link>
);
